import { useMemo, useState } from "react";

export default function useFoodFilters(foods = []) {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [dietType, setDietType] = useState("All");
  const [availability, setAvailability] = useState("All");
  const [sortBy, setSortBy] = useState("Newest");

  const filteredFoods = useMemo(() => {
    let result = [...foods];

    // Search
    if (search.trim()) {
      const keyword = search.toLowerCase();

      result = result.filter((food) =>
        food.foodName?.toLowerCase().includes(keyword)
      );
    }

    // Category
    if (category !== "All") {
      result = result.filter(
        (food) => food.category === category
      );
    }

    // Diet Type
    if (dietType !== "All") {
      result = result.filter(
        (food) => food.dietType === dietType
      );
    }

    // Availability
    if (availability === "Available") {
      result = result.filter(
        (food) => food.isAvailable
      );
    }

    if (availability === "Unavailable") {
      result = result.filter(
        (food) => !food.isAvailable
      );
    }

    // Sorting
    switch (sortBy) {

      case "Name":
        result.sort((a, b) =>
          a.foodName.localeCompare(b.foodName)
        );
        break;

      case "Price Low":
        result.sort(
          (a, b) => a.price - b.price
        );
        break;

      case "Price High":
        result.sort(
          (a, b) => b.price - a.price
        );
        break;

      case "Newest":
      default:
        result.sort(
          (a, b) =>
            new Date(b.createdAt) -
            new Date(a.createdAt)
        );
    }

    return result;

  }, [
    foods,
    search,
    category,
    dietType,
    availability,
    sortBy,
  ]);

  return {
    filteredFoods,

    search,
    setSearch,

    category,
    setCategory,

    dietType,
    setDietType,

    availability,
    setAvailability,

    sortBy,
    setSortBy,
  };
}